import { MNSproCloudApi } from '..';
import {
  IosProfilesFeaturesEntry,
  IosProfilesRestrictionsEntry,
  IosUpdateConfigurationEntry,
  IosWlanEntry,
  OnboardIosNonBoundEntry,
  OnboardSharedIosEntry,
  OnboardUserBoundIosEntry,
  WindowsAdministrativeTemplatesEntry,
  WindowsAutopilotDeploymentEntry,
  WindowsCustomConfigurationEntry,
  WindowsDeviceRestrictionsEntry,
  WindowsLocalUserGroupMembershipEntry,
  WindowsSettingsCatalogueEntry,
  WindowsSharedPolicyEntry,
  WindowsUpdatePolicyEntry,
  WindowsWiFiEntry,
} from '../api/v2';

export class ProfileService {
  static async getIosProfileRestrictions(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getIosDeviceRestrictions(
      profileId,
      organizationId,
    );

    return device.data;
  }

  static async getIosWlanProfile(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getIosWlan(profileId, organizationId);

    return device.data;
  }

  static async getAndroidStoreURL(authToken: string, organizationId: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getAndroidWebToken(organizationId);

    return device.data;
  }
  static async getIosOnboardingSettings(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getDepIosEnrollmentProfilesOfOnboardProfile(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async getIosEnrollmentOnboarding(
    authToken: string,
    organizationId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const settingsResponse = await api.getOnboardSettings(organizationId);
    return settingsResponse.data;
  }

  static async getIosEnrollmentProfiles(
    authToken: string,
    organizationId: string,
    depOnboardSettingsId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);
    const settingsResponse =
      await api.getDepIosEnrollmentProfilesOfOnboardProfile(
        organizationId,
        depOnboardSettingsId,
      );

    return settingsResponse.data;
  }

  static async getAndroidGeneralDeviceCOnfig(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getAndroidDeviceRestriction(
      profileId,
      organizationId,
    );

    return device.data;
  }

  static async getAndroidWlanProfile(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getAndroidWiFiConfiguration(
      profileId,
      organizationId,
    );

    return device.data;
  }

  static async getOnboardSettings(authToken: string, organizationId: string) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getOnboardSettings(organizationId);

    return device.data;
  }

  static async getIosDeviceFeatures(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getIosDeviceFeatures(profileId, organizationId);

    return device.data;
  }

  static async deleteProfileRestriction(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteIosDeviceRestrictions(
      profileId,
      organizationId,
    );

    return device.data;
  }

  static async createIosProfileRestriction(
    authToken: string,
    organizationId: string,
    iosRestriction: IosProfilesRestrictionsEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createIosDeviceRestrictions(
      organizationId,
      iosRestriction,
    );

    return device.data;
  }

  static async createIosOnboardingUserbound(
    authToken: string,
    organizationId: string,
    onboardSettingsId: string,
    onboardUserBoundIosEntry: OnboardUserBoundIosEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createIosUserBoundOnboard(
      onboardSettingsId,
      organizationId,
      onboardUserBoundIosEntry,
    );

    return device.data;
  }

  static async createIosOnboardingNonbound(
    authToken: string,
    organizationId: string,
    onboardSettingsId: string,
    onboardIosNonBoundEntry: OnboardIosNonBoundEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createIosNonBoundOnboard(
      onboardSettingsId,
      organizationId,
      onboardIosNonBoundEntry,
    );

    return device.data;
  }

  static async createIosOnboardingShared(
    authToken: string,
    organizationId: string,
    onboardSettingsId: string,
    onboardSharedIosEntry: OnboardSharedIosEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createIosSharedOnboard(
      onboardSettingsId,
      organizationId,
      onboardSharedIosEntry,
    );

    return device.data;
  }

  static async deleteIosOnboardingShared(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteIosSharedOnboard(organizationId, profileId);

    return device.data;
  }

  static async deleteIosOnboardingNonbound(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteIosNonBoundOnboard(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async deleteIosOnboardingUserbound(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteIosUserBoundOnboard(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async deleteIosUpdateConfig(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteIosUpdateConfiguration(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async getAndroidAppStoreConfig(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getAndroidManagedStoreApp(
      profileId,
      organizationId,
    );

    return device.data;
  }

  static async createIosUpdateConfig(
    authToken: string,
    organizationId: string,
    iosUpdateConfig: IosUpdateConfigurationEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createIosUpdateConfiguration(
      organizationId,
      iosUpdateConfig,
    );

    return device.data;
  }

  static async getIosUpdateConfig(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getIosUpdateConfiguration(
      profileId,
      organizationId,
    );

    return device.data;
  }

  static async createIosDeviceFeatures(
    authToken: string,
    organizationId: string,
    features: IosProfilesFeaturesEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createIosDeviceFeatures(organizationId, features);

    return device.data;
  }

  static async deleteIosDeviceFeatures(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteIosDeviceFeatures(organizationId, profileId);

    return device.data;
  }

  static async createIosWlan(
    authToken: string,
    organizationId: string,
    wlan: IosWlanEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createIosWlan(organizationId, wlan);

    return device.data;
  }

  static async deleteIosWlan(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteIosWlan(organizationId, profileId);

    return device.data;
  }

  static async removeWindowsRegProfil(
    authToken: string,
    organizationId: string,
    groupId: string,
    configurationProfileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.removeConfigurationProfileOfMdmGroup(
      organizationId,
      [groupId],
    );

    return device.status === 200;
  }

  static async assignWindowsRegProfil(
    authtoken: string,
    organizationId: string,
    groupId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authtoken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.assignMdmGroupConfigurationProfile(
      organizationId,
      profileId,
      [groupId],
    );

    return device.status === 200;
  }

  static async changeIosRegProfile(
    authtoken: string,
    organizationId: string,
    profileId: string,
    depOnboardingSettingsId: string,
    serialnumbers: string[],
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authtoken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.assignEnrollmentProfileToIosDevices(
      organizationId,
      profileId,
      depOnboardingSettingsId,
      serialnumbers,
    );

    return device.status === 200;
  }

  static async changeWindowsRegProfil(
    authtoken: string,
    organizationId: string,
    profileId: string,
    deviceId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authtoken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.assignEnrollmentProfileToWindowsDevice(
      profileId,
      organizationId,
      deviceId,
    );

    return device.status === 200;
  }

  static async getWindowsAdministration(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getWindowsAdministration(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async deleteWindowsAdministration(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteWindowsAdministration(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async createWindowsAdministration(
    authToken: string,
    organizationId: string,
    profile: WindowsAdministrativeTemplatesEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createWindowsAdministration(
      organizationId,
      profile,
    );

    return device.data;
  }

  static async getWindowsUpdatePolicy(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getWindowsUpdatePolicy(organizationId, profileId);

    return device.data;
  }

  static async createWindowsUpdatePolicy(
    authToken: string,
    organizationId: string,
    windowsUpdate: WindowsUpdatePolicyEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createWindowsUpdatePolicy(
      organizationId,
      windowsUpdate,
    );

    return device.data;
  }

  static async deleteWindowsUpdatePolicy(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteWindowsUpdatePolicy(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async getWindowsWlan(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getWindowsWlan(organizationId, profileId);

    return device.data;
  }

  static async createWindowsWlan(
    authToken: string,
    organizationId: string,
    profile: WindowsWiFiEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createWindowsWiFi(organizationId, profile);

    return device.data;
  }

  static async deleteWindowsWlan(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteWindowsWlan(organizationId, profileId);

    return device.data;
  }

  static async getWindowsSettingsCatalogue(
    authToken: string,
    organizationId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getWindowsSettingsCatalogue(organizationId);

    return device.data;
  }

  static async deleteWindowsSettingsCatalogue(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteWindowsSettingsCatalogue(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async createWindowsSettingsCatalogue(
    authToken: string,
    organizationId: string,
    profile: WindowsSettingsCatalogueEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createWindowsSettingsCatalogue(
      organizationId,
      profile,
    );

    return device.data;
  }

  static async getWindowsLocalUserGroupMembership(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getWindowsLocalUserGroupMembership(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async deleteWindowsLocalUserGroupMembership(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteWindowsLocalUserGroupMembership(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async createWindowsLocalUserGroupMembership(
    authToken: string,
    organizationId: string,
    profile: WindowsLocalUserGroupMembershipEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createWindowsLocalUserGroupMembership(
      organizationId,
      profile,
    );

    return device.data;
  }

  static async getWindowsShared(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getWindowsShared(organizationId, profileId);

    return device.data;
  }

  static async createWindowsShared(
    authToken: string,
    organizationId: string,
    profile: WindowsSharedPolicyEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createWindowsShared(organizationId, profile);

    return device.data;
  }

  static async deleteWindowsShared(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteWindowsShared(organizationId, profileId);

    return device.data;
  }

  static async getWindowsAutopilot(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getWindowsAutopilotRestrictions(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async getWindowsEnrollmentProfiles(
    authToken: string,
    organizationId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const enrollmentProfiles = await api.getWindowsAutopilotProfiles(
      organizationId,
    );

    return enrollmentProfiles.data;
  }

  static async createWindowsAutopilot(
    authToken: string,
    organizationId: string,
    profile: WindowsAutopilotDeploymentEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createWindowsAutopilotProfile(
      organizationId,
      profile,
    );

    return device.data;
  }

  static async deleteWindowsAutopilot(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteWindowsAutopilotRestrictions(
      organizationId,
      profileId,
    );

    return device.data;
  }
  static async getWindowsDeviceRestrictions(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getWindowsDeviceRestrictions(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async createWindowsDeviceRestrictions(
    authToken: string,
    organizationId: string,
    profile: WindowsDeviceRestrictionsEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createWindowsDeviceRestrictions(
      organizationId,
      profile,
    );

    return device.data;
  }

  static async deleteWindowsDeviceRestrictions(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteWindowsDeviceRestrictions(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async getWindowsCustomConfig(
    authToken: string,
    organizationId: string,
    profileId: string | undefined,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.getWindowsCustomConfiguration(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async createWindowsCustomConfig(
    authToken: string,
    organizationId: string,
    profile: WindowsCustomConfigurationEntry,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.createWindowsCustomConfiguration(
      organizationId,
      profile,
    );

    return device.data;
  }

  static async deleteWindowsCustomConfig(
    authToken: string,
    organizationId: string,
    profileId: string,
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.deleteWindowsCustomConfiguration(
      organizationId,
      profileId,
    );

    return device.data;
  }

  static async assignConfigProfile(
    authToken: string,
    organizationId: string,
    profileId: string,
    groupIds: string[],
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.assignMdmGroupConfigurationProfile(
      organizationId,
      profileId,
      groupIds,
    );

    return device.data;
  }

  static async removeConfigProfile(
    authToken: string,
    organizationId: string,
    profileId: string,
    groupIds: string[],
  ) {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.MdmApiFactory(config);

    const device = await api.removeConfigurationProfileOfMdmGroup(
      organizationId,
      groupIds,
      profileId,
    );

    return device.data;
  }
}
